import { render } from "./specificGift_winnerList.vue?vue&type=template&id=c13474d0"
import script from "./specificGift_winnerList.vue?vue&type=script&lang=js"
export * from "./specificGift_winnerList.vue?vue&type=script&lang=js"
script.render = render

export default script